module.exports = __webpack_public_path__ + "static/me-min-e68f364cea050c56bce5c7ed3aac4427.png";